import req from './http.js'

export const apiGetSubscriptionInfoFeature = (org_id) => req('get', '/subscription/info?org=' + org_id)

export const apiGetSubscriptionLevel = (org_id) => req('get', '/subscription/level?org=' + org_id)

// 訂閱功能列表
export const apiGetSubscriptionTree = () => req(
    'get',
    `/view/subscription/tree`,
    null
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})